import * as React from 'react';

import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(
                'typ-body-x30 flex h-9 w-full rounded-x30 border border-stroke-x30 bg-surface-x10 px-2.5 text-text-x10 transition-colors placeholder:text-text-x30 hover:border-text-x30 focus:border-stroke-x10 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = 'Input';

export { Input };
